import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';
import { FilterSearchingSolicitudExViewModel } from './buscador-solicitudEx.types';
import { SolicitudExViewModel } from '../../solicitudes/datosbasicos/datosbasicosEx.types';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';

///https://angular.io/tutorial/toh-pt6
//https://malcoded.com/posts/angular-backend-asp-core

@Injectable()
export class BuscadorSolicitudExService extends ResetFiltersService {
    public currentFilterSolicitudEx = new FilterSearchingSolicitudExViewModel();

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    postSolicitudPagedByFilter(model: FilterSearchingSolicitudExViewModel): Observable<any> {
        return this.http.post<FilterSearchingSolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/postPagedbyfilter', model).pipe();
    }

    comprobarEstadosEphytos(model: FilterSearchingSolicitudExViewModel): Observable<any> {
        return this.http.post<FilterSearchingSolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/comprobarEstadosEphytos', model).pipe();
    }

    export(model: FilterSearchingSolicitudExViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/solicitudEx/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    deleteSolicitud(id: number): Observable<any> {
        return this.http.delete<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/' + id).pipe();
    }

    cloneSolicitud(params: HttpParams): Observable<any> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/cloneSolicitud/', { params: params }).pipe();
    }

    resetFilter() {
        this.currentFilterSolicitudEx = new FilterSearchingSolicitudExViewModel();
    }
}
